import { createApiCall } from "services/api/createApiCall";
import { FleetVehicleEquipment, FleetVehicleEquipmentItem } from "./types";
import { transformFleetVehicleEquipment, transformFleetVehicleEquipmentRequest } from "./transformations";

/*---------------------------------------------------------------------------------------
  EQUIPMENT - GET
-----------------------------------------------------------------------------------------*/
export const getFleetVehicleEquipmentAPI = async (
  vehicleId: string
): Promise<FleetVehicleEquipment[]> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${vehicleId}/equipment`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data.map(transformFleetVehicleEquipment);
};

/*---------------------------------------------------------------------------------------
  EQUIPMENT - SAVE (replace whole list)
-----------------------------------------------------------------------------------------*/
export const saveFleetVehicleEquipmentAPI = async (
  vehicleId: string,
  items: FleetVehicleEquipmentItem[]
): Promise<FleetVehicleEquipment[]> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/vehicles/${vehicleId}/equipment`,
      method: "PUT",
      body: transformFleetVehicleEquipmentRequest(items),
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data.map(transformFleetVehicleEquipment);
};
